export default __webpack_public_path__ + "static/1996-12-05_identifying_ASA.pdf";